import { Language } from '@/data/modules/cv';
import { useData } from '@/i18n/LangContext';

interface CvLanguagesProps {
  languages?: Language[];
}

export default function CvLanguages({ languages }: CvLanguagesProps) {
  const data = useData();
  const items = languages ?? data.cv.languages;
  return (
    <div className="flex flex-wrap gap-4 print:gap-1.5">
      {items.map((language, index) => (
        <div 
          key={index} 
          className="px-4 py-3 rounded-lg bg-[rgba(198,156,109,0.1)] border border-[rgba(198,156,109,0.2)] print:bg-white print:border-gray-300 print:py-1.5 print:px-3"
        >
          <div className="font-semibold print:text-black">{language.name}</div>
          <div className="text-sm text-white/70 print:text-gray-700">{language.level}</div>
        </div>
      ))}
    </div>
  );
} 